export const CheckBoxUnchecked = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <rect x="0.5" y="0.5" width="19" height="19" rx="4.5" stroke="#043F86" />
        </svg>
    );
};

